import {importProvidersFrom, NgModule} from '@angular/core';
import { CardPanPipe } from './card-pan.pipe';
import { OpacityPipe } from './opacity.pipe';
import { CommonPipesModule } from 'common-framework';

const pipes :any[] = [
  CardPanPipe,
  OpacityPipe
];
@NgModule({
  declarations: [
    ...pipes
  ],
  imports: [
    CommonPipesModule
  ],
  exports: [
    ...pipes,
    CommonPipesModule
  ],
  providers: [
    ...pipes,
    importProvidersFrom(CommonPipesModule)
  ]
})
export class PipesModule{ }
